export const translations = {
  fr: {
    // Navigation
    accueil: "Accueil",
    checklist: "Checklist",
    autonomie: "Autonomie",
    dossiers: "Dossiers",
    depenses: "Dépenses",
    rapport: "Rapport",
    diagnostic: "Diagnostic",
    diagnosticTitre: "Page Diagnostic",
    diagnosticDesc: "Cette page est en cours de construction.",
    diagBientotDispo: "Les fonctions diagnostic de cette page seront bientôt disponibles",

    // Onboarding
    nomDuVan: "Nom du van",
    immatriculation: "Immatriculation",
    creerMonVan: "Créer mon van",

    // Accueil
    synchronise: "Synchronisé",
    conseils: "Conseils",
    kmCompteur: "km compteur",
    toutAJour: "✓ Tout est à jour",
    echeances: "échéance(s)",
    rappels: "RAPPELS",
    assurance: "Assurance",
    revision: "Révision",
    ct: "CT",
    meteo: "MÉTÉO",
    checklist_label: "CHECKLIST",
    autonomie_label: "AUTONOMIE",
    boutonSecours: "BOUTON DE SECOURS",
    accidentAssistance: "Accident · Assistance · Constat · Services proches",

    // Checklist
    progression: "Progression",
    attention: "attention",
    probleme: "problème",
    entretienComplet: "Entretien complet — tout est OK !",
    pointsARegler: "point(s) à régler",
    entretienVehicule: "Entretien du véhicule",
    vehicule: "Véhicule",
    depart: "Départ",

    // Dossiers
    dossiers_titre: "Dossiers",
    documentsVehicule: "Documents du véhicule",
    documentsARenouveler: "document(s) à renouveler",
    coordonnees: "Coordonnées",
    enregistrer: "Enregistrer",
    modifier: "Modifier",
    appelerAssurance: "Appeler l'assurance",
    appelerGarage: "Appeler le garage",
    echeance: "Échéance",
    prochaineRevision: "PROCHAINE RÉVISION",
    kilometrage: "KILOMÉTRAGE",
    scanner: "+ Scanner une facture",

    // Dépenses
    depenses_titre: "Dépenses",
    depart_label: "Départ",
    arrivee: "Arrivée",
    carburant: "Carburant",
    general: "Général",
    stats: "Stats",
    nouveauPlein: "Nouveau plein",
    enregistrerPlein: "Enregistrer le plein",
    annuler: "Annuler",
    date: "DATE",
    kmCompteurLabel: "KM COMPTEUR",
    prixTotal: "PRIX TOTAL (€)",
    litres: "LITRES",
    montant: "MONTANT (€)",
    categorie: "CATÉGORIE",
    description: "DESCRIPTION",
    enregistrerBtn: "Enregistrer",
    aucunPlein: "Aucun plein enregistré",
    aucuneDepense: "Aucune dépense enregistrée",
    consoLabel: "Consommation L/100km",
    moyLabel: "Moy :",
    consoMin2: "Enregistrez au moins 2 pleins pour voir la courbe de consommation",
    consoMin1: "Enregistrez encore 1 plein pour voir la courbe",
    optionnel: "Optionnel",
    kilometrageCompteur: "KILOMÉTRAGE AU COMPTEUR (km)",
    ceMoisCi: "CE MOIS-CI",
    depensesDuMois: "DÉPENSES DU MOIS",
    depensesTotalGeneralCarbu: "DÉPENSES TOTAL GÉNÉRAL + CARBURANT",
    depensesTotalCarbu: "DÉPENSES TOTAL CARBURANT",
    totalDepensesGeneral: "TOTAL DÉPENSES GÉNÉRAL",
    total12Mois: "TOTAL DÉPENSES GÉNÉRAL 12 DERNIERS MOIS",
    depensesTotalDuMois: "Total dépenses général du mois",
    depensesTotalesLabel: "dépenses totales",
    parcourus: "parcourus",
    douzeMois: "12 DERNIERS MOIS",
    aucuneDonnee: "Aucune donnée disponible",
    voyageSection: "VOYAGE",
    aucunVoyageDepenses: "Aucun voyage enregistré — renseignez les dates de départ et d'arrivée dans l'onglet Dépenses.",
    jours: "jours",
    essence: "Essence",
    eau: "Eau",
    gaz: "Gaz",
    electricite: "Électricité",
    batterie: "Batterie",
    eauxUsees: "Eaux usées",
    camping: "Camping",
    aireDeRepos: "Aire de repos",
    peage: "Péage",
    totalVoyage: "Total voyage",
    enregistreFlash: "✓ Enregistré",
    departLabel: "Départ",
    arriveeLabel: "Arrivée",
    catFinancement: "Financement",
    catAssurance: "Assurance",
    catControle: "Contrôle technique",
    catGarage: "Garage",
    catPeage: "Péage",
    catLavage: "Lavage",
    catEau: "Eau",
    catGaz: "Gaz",
    catCamping: "Camping",
    catAire: "Aire de repos",
    catParking: "Parking",
    catHivernage: "Hivernage",
    catContravention: "Contravention",

    // Rapport
    rapport_titre: "Rapport",
    mesStats: "Mes stats",
    passeportQR: "Passeport QR",
    donneesPrivees: "Données privées — non incluses dans le QR",
    kilometrage_label: "KILOMÉTRAGE",
    kmAuCompteur: "km au compteur",
    kmParcourus: "km parcourus",
    consommation: "CONSOMMATION MOYENNE",
    depensesTotales: "DÉPENSES TOTALES",
    statsVoyage: "STATISTIQUES VOYAGE",
    aucunVoyage: "Aucun voyage enregistré",
    telechargerPDF: "Télécharger en PDF",
    partagerPasseport: "📤 Partager le passeport",
    idCertificat: "ID CERTIFICAT",
    statistiques: "STATISTIQUES",
    verificationsEffectuees: "Vérifications effectuées",
    interventionsEnregistrees: "Interventions enregistrées",
    derniereActivite: "Dernière activité",
    facturesGarage: "FACTURES GARAGE",
    van: "VAN",
    totalDepenses: "Total dépenses",
    consommationLabel: "Consommation",
    partagerTitre: "Passeport entretien",
    partagerTexte: "Voici le passeport d'entretien de mon camping-car",
    // Secours
    resteCalme: "Reste calme, on est là. 🤜",
    enCasAccident: "En cas d'accident",
    procedureSecurite: "Procédure · Sécurité · Assistance",
    guideConstat: "Guide constat européen",
    remplirConstat: "Remplir sans erreur étape par étape",
    servicesProches: "Services proches",
    garageStation: "Garage / Dépannage et Station service",
    appelRapide: "APPEL RAPIDE",
    pompiers: "Pompiers",
    police: "Police",
    europe: "Europe",
    suivezEtapes: "Suivez ces étapes dans l'ordre",
    securiserZone: "Sécuriser la zone",
    securiserZoneDesc: "Coupez le moteur. Mettez le gilet jaune AVANT de sortir du véhicule. Placez le triangle à 30 m minimum.",
    verifierBlesses: "Vérifier les blessés",
    verifierBlessesDesc: "Si blessé grave : appelez le 15 (SAMU) ou le 18 (pompiers). Ne déplacez pas les blessés.",
    appelerSecours: "Appeler les secours",
    appelerSecoursDesc: "Police/Gendarmerie : 17 · SAMU : 15 · Pompiers : 18 · Numéro européen : 112",
    contacterAssurance: "Contacter l'assurance",
    contacterAssuranceDesc: "Déclarez le sinistre dans les 5 jours ouvrés. Remplissez le constat à l'amiable.",
    huitEtapes: "8 étapes pour remplir sans erreur",
    ouvreMaps: "Ouvre Google Maps directement près de ta position",
    garageDepannage: "Garage / Dépannage",
    mapsPres: "Google Maps s'ouvre près de toi",
    stationService: "Station service",
    retour: "← Retour",
    constatStep1title: "Date, heure et lieu",
    constatStep1desc: "Notez précisément la date, l'heure et l'adresse exacte de l'accident.",
    constatStep2title: "Blessés ?",
    constatStep2desc: "Indiquez s'il y a des blessés. Si oui, appelez le 15 immédiatement.",
    constatStep3title: "Dommages matériels",
    constatStep3desc: "Décrivez les dégâts visibles sur chaque véhicule. Prenez des photos.",
    constatStep4title: "Témoins",
    constatStep4desc: "Relevez les noms et coordonnées de tous les témoins présents.",
    constatStep5title: "Véhicule A & B",
    constatStep5desc: "Remplissez les informations de chaque véhicule : marque, modèle, immatriculation.",
    constatStep6title: "Assurances",
    constatStep6desc: "Notez les numéros de contrat et les coordonnées des assureurs des deux parties.",
    constatStep7title: "Croquis de l'accident",
    constatStep7desc: "Dessinez un schéma clair de la position des véhicules au moment du choc.",
    constatStep8title: "Signatures obligatoires",
    constatStep8desc: "Les deux conducteurs DOIVENT signer le constat. Sans signature, il n'a aucune valeur.",
    constatStep9title: "Ne jamais reconnaître sa faute",
    constatStep9desc: "Ne signez aucun document sans l'accord de votre assureur.",
    // Dossiers
    garage: "Garage",
    factures: "Factures",
    nouvelleFacture: "Nouvelle facture",
    prendrePhoto: "📷 Prendre une photo",
    photoChange: "✅ Photo prise — changer",
    sauvegarde: "Sauvegarde…",
    chargement: "Chargement…",
    aucuneFacture: "Aucune facture",
    expire: "Expiré",
    aJour: "À jour",
    aucuneDateRappel: "Aucune date — le rappel n'apparaîtra pas sur l'Accueil",
    docExpire: "Document expiré — renouvelez-le dès que possible",
    joursRestants: " jour(s) restant(s) — rappel actif sur l'Accueil",
    prochaineRevisionA: "Prochaine révision à",
    nomAssurance: "NOM DE L'ASSURANCE",
    adresse: "ADRESSE",
    numeroContrat: "NUMÉRO DE CONTRAT",
    numereTelephone: "NUMÉRO DE TÉLÉPHONE",
    exAssurance: "Ex : MAIF, AXA, Allianz…",
    exAdresse: "Ex : 12 rue de la Paix, Paris",
    exContrat: "Ex : 12345678",
    exTel: "Ex : 0800 000 000",
    echeanceLabel: "ÉCHÉANCE",
    nomGarage: "NOM DU GARAGE",
    exGarage: "Ex : Garage Dupont",
    exAdresseGarage: "Ex : 12 avenue du Maréchal, Lyon",
    exTelGarage: "Ex : 04 00 00 00 00",
    exKmRevision: "Ex : 65 000",
    controleTechnique: "CONTRÔLE TECHNIQUE",
    aucuneDate: "Aucune date",
    // Checklist
    attentionBtn: "Attention !",
    problemeBtn: "❌ Problème",
    diagnosticOBD2: "Diagnostic OBD2",
    bientotDispo: "🚧 BIENTÔT DISPONIBLE",
    diagIA_titre: "Diagnostic IA",
    diagIA_sous_titre: "Identifiez vos voyants tableau de bord",
    diagIA_desc: "Prenez en photo les voyants allumés de votre tableau de bord. L'IA identifie chaque voyant, vous explique la cause probable et la marche à suivre.",
    diagIA_photo_label: "Photographiez vos voyants allumés",
    diagIA_photo_desc: "L'IA identifie chaque voyant et vous explique la cause probable et la marche à suivre",
    diagIA_feat1: "Identification instantanée des voyants",
    diagIA_feat2: "Analyse IA de la cause probable",
    diagIA_feat3: "Conseils d'urgence et marche à suivre",
    diagIA_soon: "Disponible dans la version 2 de CheckVan",
    diagIA_btn: "Scanner mes voyants — Bientôt disponible",
    obd2Soon: "Fonctionnalité en cours de développement",
    connecterOBD2: "Connecter un adaptateur OBD2",
    // Départ
    toutVerifie: "✓ Tout est vérifié — Bon voyage !",
    ajouterBtn: "Ajouter",
    nouvelElement: "Nouvel élément à vérifier…",
    ajoutezPropres: "Ajoutez vos propres éléments à vérifier avant le départ",
    aNePasOublier: "À NE PAS OUBLIER",
    supprimer: "🗑️ Supprimer",
    stockagePlein: "⚠️ Stockage presque plein — supprimez des photos",
    confirmerSuppression: "Confirmer ?",
    viderCache: "Vider le cache local",
    tabVoyage: "Voyage",
    tabHivernal: "Hivernal",
    tabSecurite: "Sécurité",
    tabPerso: "Personnalisé",
    // Autonomie
    jour: "jour",
    surLabel: "sur",
    capacitesVan: "CAPACITÉS DU VAN",
    valider: "Valider",
    capaciteEau: "Capacité eau",
    capaciteGaz: "Capacité gaz",
    capaciteEauxUsees: "Capacité eaux usées",
    renseignezCapacites: "Renseignez les capacités de votre van pour commencer",
    autonomieSuffisante: "✓ Autonomie suffisante",
    autonomieLimitee: "⚠ Autonomie limitée",
    ressourcesCritiques: "⛽ Ressources critiques",
    avantVidange: "avant vidange",
    conditionsVoyage: "CONDITIONS DE VOYAGE",
    personnesABord: "Personnes à bord",
    reservoirCritique: "Réservoir critique — trouvez un point d'eau",
    bouteilleVide: "Bouteille presque vide — rechargez bientôt",
    tankCharge: "Tank chargé — prévoyez une vidange",
    batterieFaible: "Batterie faible — branchez ou exposez les panneaux",
    predictionsAvantDepart: "Prédictions avant départ",
    // Onboarding
    configurezVotreVan: "Configurez votre van",
    aFaireUneFois: "À faire une seule fois",
    exNomVan: "Ex : Vagabond, Mon Hymer…",
    nomRequis: "Le nom du van est requis.",
    enregistrementEnCours: "Enregistrement…",
    // Premium
    plansCheckVan: "✨ Plans CheckVan",
    choisissezFormule: "Choisissez votre formule",
    mensuel: "Mensuel",
    annuel: "Annuel −30%",
    gratuit: "Gratuit",
    premium: "Premium",
    ultra: "Ultra",
    recommande: "★ RECOMMANDÉ",
    parMois: "/mois",
    parAn: "/an",
    ou: "ou",
    planActuel: "Plan actuel",
    choisirPremium: "Choisir Premium",
    choisirUltra: "Choisir Ultra",
    fermer: "Fermer",
    // Premium features
    feat_1Vehicule: "1 véhicule",
    feat_checklistEntretien: "Checklist entretien",
    feat_documents: "Documents",
    feat_rappels: "Rappels",
    feat_boutonSecours: "Bouton secours",
    feat_certificatQR: "Certificat QR code",
    feat_meteoJour: "Météo du jour",
    feat_toutGratuit: "Tout le gratuit +",
    feat_multilingue: "Multilingue FR/EN (auto)",
    feat_diagnosticIA: "Diagnostic IA des voyants",
    feat_exportPDF: "Export PDF avancé",
    feat_depenses3mois: "Dépenses & Km 3 mois",
    feat_stats3mois: "Statistiques 3 mois",
    feat_historique3mois: "Historique 3 mois",
    feat_meteo3jours: "Prévisions météo 3 jours",
    feat_toutPremium: "Tout le premium +",
    feat_pdfOCR: "PDF avancé + Scanner OCR",
    feat_notifications: "Notifications push",
    feat_pwa: "PWA installable",
    feat_depensesIllimite: "Dépenses & Km illimité",
    feat_stats12mois: "Statistiques 12 mois",
    feat_historiqueIllimite: "Historique illimité",
    feat_obd2: "Diagnostic OBD2 🔌",
    feat_diagIA: "Diagnostic voyants IA 🔍",
    feat_meteo7jours: "Prévisions météo 7 jours",
    // Menu
    monVan: "Mon Van",
    compte: "COMPTE",
    reconfigurerVan: "🔄 Reconfigurer le van",
    seDeconnecter: "⏏ Se déconnecter",
    // Accueil — modals
    conseilsVoyage: "💡 Conseils voyage",
    carnetBord: "Carnet de bord numérique",
    langue: "LANGUE",
    compteConnecte: "COMPTE CONNECTÉ",
    voirPlans: "Voir les plans Premium",
    installerApp: "Installer l'app sur le téléphone",
    activerNotifs: "Activer les notifications",
    partagerApp: "Partager l'app",
    supprimerCompte: "Supprimer mon compte",
    confirmerSuppressionCompte: "Confirmer la suppression ?",
    suppressionEnCours: "Suppression...",
    erreurReconnexion: "Veuillez vous déconnecter puis vous reconnecter avant de supprimer le compte.",
    erreurSuppression: "Erreur : ",
    cguConfidentialite: "CGU & Politique de confidentialité",
    conseilEauxUsees: "Les eaux usées sont presque pleines — videz-les en priorité.",
    conseilEauBasse: "Réservoir d'eau critique — trouvez un point d'eau.",
    conseilGazBas: "Bouteille de gaz presque vide — rechargez bientôt.",
    conseilBatterieBasse: "Batterie faible — branchez ou exposez les panneaux.",
    conseilSurveiller: "Quelques ressources à surveiller avant le départ.",
    conseilOk: "Autonomie correcte — partez l'esprit tranquille.",
    // Checklist véhicule — catégories
    catMoteur: "Moteur & Fluides",
    catPneus: "Pneumatiques",
    catEclairage: "Éclairage",
    catCellule: "Cellule équipements",
    // Checklist véhicule — items
    ent_huile: "Niveau d'huile moteur", ent_huile_desc: "Jauge entre min et max",
    ent_refroid: "Liquide de refroidissement", ent_refroid_desc: "Niveau au repère froid",
    ent_frein: "Liquide de frein", ent_frein_desc: "Au-dessus du minimum",
    ent_laveglace: "Lave-glace", ent_laveglace_desc: "Réservoir plein",
    ent_filtre_air: "Filtre à air", ent_filtre_air_desc: "État et propreté",
    ent_pression: "Pression des pneus (av et ar)", ent_pression_desc: "Conforme constructeur",
    ent_usure_av: "Usure pneus avant", ent_usure_av_desc: "Sculptures > 1,6 mm",
    ent_usure_ar: "Usure pneus arrière", ent_usure_ar_desc: "Sculptures > 1,6 mm",
    ent_secours: "Roue de secours", ent_secours_desc: "Gonflée et accessible",
    ent_phares: "Phares et feux avant", ent_phares_desc: "Fonctionnels",
    ent_stop: "Feux stop", ent_stop_desc: "Fonctionnels",
    ent_cligno: "Clignotants", ent_cligno_desc: "Avant et arrière",
    ent_recul: "Feux de recul + plaque", ent_recul_desc: "Fonctionnels",
    ent_ce_freins: "Freins", ent_ce_freins_desc: "Usure et efficacité",
    ent_ce_batt: "Batterie", ent_ce_batt_desc: "Charge et état général",
    ent_ce_essuie: "Essuie-glaces", ent_ce_essuie_desc: "État des balais",
    ent_ce_clim: "Climatisation", ent_ce_clim_desc: "Fonctionnelle et filtre propre",
    obd2Desc: "Connectez un adaptateur OBD2 Bluetooth pour lire les codes d'erreur de votre camping-car et obtenir une analyse IA.",
    conseilTitre1: "La Stat de Poids — PTAC",
    conseilTexte1: "La plupart des camping-cars se conduisent avec un permis B et sont limités à 3,5 tonnes. La Charge Utile est la différence entre le poids à vide et le PTAC (souvent 400 à 600 kg). Calculez : Passagers + plein d'eau (100L = 100kg) + gaz + effets personnels + vélos.\n\n💬 Conseil : Ne partez jamais avec le réservoir d'eau plein à 100% si vous avez de la route.",
    conseilTitre2: "Autonomie et Ressources",
    conseilTexte2: "• Eau : ~20 litres/jour/personne. Avec 100L, vous tenez 2 à 3 jours à deux.\n• Énergie : Ne descendez pas sous 12,2V (50% de charge) pour ne pas abîmer la batterie.\n• Gaz : Une bouteille de 13kg dure plusieurs semaines en été, mais 3 à 4 jours en hiver avec chauffage intensif.",
    conseilTitre3: "Dimensions et Navigation",
    conseilTexte3: "• Hauteur : Entre 2,80m et 3,10m. Notez-la sur un post-it sur votre tableau de bord.\n• Porte-à-faux : En virage serré, l'arrière balaye l'extérieur. Gardez toujours une marge de manœuvre.",
    conseilTitre4: "Organisation Numérique",
    conseilTexte4: "• Apps de stationnement pour trouver des aires de services ou spots autorisés.\n• Check-lists de départ : fermer les bouteilles de gaz, rentrer le marchepied, verrouiller les placards, fermer les lanterneaux.",
    conseilTitre5: "Le petit plus Sérénité",
    conseilTexte5: "Emportez une petite boîte à outils (fusibles, ampoules, colliers de serrage). Un camping-car subit beaucoup de vibrations — il n'est pas rare de devoir resserrer une vis ou changer un fusible de pompe à eau en route.",
    conseilTitre6: "Animaux de compagnie",
    conseilTexte6: "Avant de partir\n• Administratif : Animal identifié (puce/tatouage), vaccins à jour (rage obligatoire pour l'étranger) et passeport européen si vous passez les frontières.\n• Santé : Prévoir une trousse de secours (tire-tique, désinfectant) et anticiper le mal des transports.\n\nSur la route — Sécurité\n• Attache obligatoire : Harnais de sécurité ou caisse de transport fixée (jamais d'animal en liberté pendant que vous roulez).\n• Pauses : S'arrêter toutes les deux heures pour l'eau, les besoins et le dégourdir.",
    // Items Départ — Voyage
    dep_fenetre: "Fenêtres fermées", dep_fenetre_desc: "Verrouillées et étanches",
    dep_store: "Store rentré", dep_store_desc: "Auvent replié",
    dep_frigo: "Frigo en 12V", dep_frigo_desc: "Basculer sur batterie",
    dep_antenne: "Antenne TV", dep_antenne_desc: "Repliée et fixée",
    dep_robinets: "Robinets fermés", dep_robinets_desc: "Circuit eau coupé",
    dep_gaz: "Gaz coupé", dep_gaz_desc: "Robinet principal fermé",
    dep_joints: "Joints de fenêtres", dep_joints_desc: "Pas de fissures ni décollement",
    dep_toit: "Toit et lanterneaux", dep_toit_desc: "Étanches, pas de fissure",
    dep_trappe: "Trappe eau propre", dep_trappe_desc: "Pas de fuite autour",
    dep_marchepied: "Marchepied rentré", dep_marchepied_desc: "Fixé pour la route",
    dep_cable220: "Câble 220V", dep_cable220_desc: "Déconnecté et rangé",
    dep_placards: "Placards fermés", dep_placards_desc: "Tous verrouillés",
    // Items Départ — Hivernal
    hiv_batterie: "Batterie débranchée", hiv_batterie_desc: "Borne négative déconnectée",
    hiv_eau: "Circuits eau vidangés", hiv_eau_desc: "Pompe, chauffe-eau, durites",
    hiv_antigel: "Antigel ajouté", hiv_antigel_desc: "Siphons et WC",
    hiv_gaz: "Gaz fermé", hiv_gaz_desc: "Bouteilles déconnectées",
    hiv_frigo: "Frigo ouvert", hiv_frigo_desc: "Porte calée ouverte",
    hiv_ventilation: "Ventilation ouverte", hiv_ventilation_desc: "Éviter la condensation",
    hiv_pneus: "Pression pneus", hiv_pneus_desc: "Gonfler à +0,2 bar",
    hiv_bache: "Bâche installée", hiv_bache_desc: "Protégée des UV et humidité",
    // Items Départ — Sécurité
    sec_gilet: "Gilets jaunes", sec_gilet_desc: "Accessibles sans ouvrir le coffre",
    sec_triangle: "Triangle de sécurité", sec_triangle_desc: "Conforme et accessible",
    sec_extincteur: "Extincteur", sec_extincteur_desc: "Chargé et accessible",
    sec_trousse: "Trousse de secours", sec_trousse_desc: "Complète et à jour",
    sec_detecteur: "Détecteur CO/Gaz", sec_detecteur_desc: "Testé et fonctionnel",
    sec_assurance: "Assurance à jour", sec_assurance_desc: "Carte verte dans le véhicule",
    sec_permis: "Permis & papiers", sec_permis_desc: "Présents dans le véhicule",
    // Outils
    outils: "Outils",
    outils_titre: "Outils de terrain",
    outils_sous_titre: "Capteurs de votre smartphone",
    outil_niveau: "Niveau à bulle",
    outil_niveau_btn: "Activer le niveau",
    outil_inclinometre: "Inclinomètre de sécurité",
    outil_incl_btn: "Activer l'inclinomètre",
    outil_boussole: "Boussole solaire",
    outil_boussole_btn: "Activer la boussole",
    outil_conseil_solaire: "Garez-vous face au SUD pour des panneaux solaires optimaux",
    inactif: "Inactif",
    autoriser_capteur: "Autoriser le capteur (iOS)",
    desactiver: "Désactiver",
    cale_gauche: "Calez roue GAUCHE",
    cale_droite: "Calez roue DROITE",
    cale_avant: "Calez les roues AVANT",
    cale_arriere: "Calez les roues ARRIÈRE",
    incl_ok: "✅ Inclinaison normale",
    incl_warn: "⚠️ Attention — inclinaison importante",
    incl_danger: "🚨 DANGER — risque de basculement",
    activer_gps: "Activer la géolocalisation",
    lever: "Lever",
    coucher: "Coucher",
    niveau_titre: "Niveau à bulle",
    niveau_ok: "✅ Véhicule à niveau",
    niveau_cale_gauche: "Calez la roue GAUCHE",
    niveau_cale_droite: "Calez la roue DROITE",
    niveau_cale_avant: "Calez les roues AVANT",
    niveau_cale_arriere: "Calez les roues ARRIÈRE",
    niveau_activer: "Activer le niveau",
    niveau_permission: "Autoriser l'accès aux capteurs",
    inclinometre_titre: "Inclinomètre de sécurité",
    inclinometre_ok: "✅ Inclinaison normale",
    inclinometre_attention: "⚠️ Attention — inclinaison importante",
    inclinometre_danger: "🚨 DANGER — risque de basculement",
    boussole_titre: "Boussole solaire",
    boussole_lever: "Lever du soleil",
    boussole_coucher: "Coucher du soleil",
    boussole_activer_gps: "Activer la géolocalisation",
  },
  en: {
    // Navigation
    accueil: "Home",
    checklist: "Checklist",
    autonomie: "Autonomy",
    dossiers: "Documents",
    depenses: "Expenses",
    rapport: "Report",
    diagnostic: "Diagnostic",
    diagnosticTitre: "Diagnostic Page",
    diagnosticDesc: "This page is under construction.",
    diagBientotDispo: "Diagnostic features on this page will be available soon",

    // Onboarding
    nomDuVan: "Van name",
    immatriculation: "Registration",
    creerMonVan: "Create my van",

    // Accueil
    synchronise: "Synced",
    conseils: "Tips",
    kmCompteur: "km odometer",
    toutAJour: "✓ Everything up to date",
    echeances: "deadline(s)",
    rappels: "REMINDERS",
    assurance: "Insurance",
    revision: "Service",
    ct: "MOT",
    meteo: "WEATHER",
    checklist_label: "CHECKLIST",
    autonomie_label: "AUTONOMY",
    boutonSecours: "EMERGENCY BUTTON",
    accidentAssistance: "Accident · Assistance · Report · Nearby services",

    // Checklist
    progression: "Progress",
    attention: "warning",
    probleme: "issue",
    entretienComplet: "Full service — everything is OK!",
    pointsARegler: "issue(s) to fix",
    entretienVehicule: "Vehicle maintenance",
    vehicule: "Vehicle",
    depart: "Departure",

    // Dossiers
    dossiers_titre: "Documents",
    documentsVehicule: "Vehicle documents",
    documentsARenouveler: "document(s) to renew",
    coordonnees: "Contact details",
    enregistrer: "Save",
    modifier: "Edit",
    appelerAssurance: "Call insurance",
    appelerGarage: "Call garage",
    echeance: "Expiry",
    prochaineRevision: "NEXT SERVICE",
    kilometrage: "MILEAGE",
    scanner: "+ Scan an invoice",

    // Dépenses
    depenses_titre: "Expenses",
    depart_label: "Departure",
    arrivee: "Arrival",
    carburant: "Fuel",
    general: "General",
    stats: "Stats",
    nouveauPlein: "+ New fill-up",
    enregistrerPlein: "Save fill-up",
    annuler: "Cancel",
    date: "DATE",
    kmCompteurLabel: "ODOMETER (KM)",
    prixTotal: "TOTAL PRICE (€)",
    litres: "LITRES",
    montant: "AMOUNT (€)",
    categorie: "CATEGORY",
    description: "DESCRIPTION",
    enregistrerBtn: "Save",
    aucunPlein: "No fill-up recorded",
    aucuneDepense: "No expense recorded",
    consoLabel: "Consumption L/100km",
    moyLabel: "Avg:",
    consoMin2: "Record at least 2 fill-ups to see the consumption chart",
    consoMin1: "Record 1 more fill-up to see the chart",
    optionnel: "Optional",
    kilometrageCompteur: "ODOMETER READING (km)",
    ceMoisCi: "THIS MONTH",
    depensesDuMois: "MONTHLY EXPENSES",
    depensesTotalGeneralCarbu: "TOTAL EXPENSES GENERAL + FUEL",
    depensesTotalCarbu: "TOTAL FUEL EXPENSES",
    totalDepensesGeneral: "TOTAL GENERAL EXPENSES",
    total12Mois: "TOTAL GENERAL EXPENSES LAST 12 MONTHS",
    depensesTotalDuMois: "Total general expenses this month",
    depensesTotalesLabel: "total expenses",
    parcourus: "travelled",
    douzeMois: "LAST 12 MONTHS",
    aucuneDonnee: "No data available",
    voyageSection: "TRIP",
    aucunVoyageDepenses: "No trip recorded — enter your departure and arrival dates in the Expenses tab.",
    jours: "days",
    essence: "Fuel",
    eau: "Water",
    gaz: "Gas",
    electricite: "Electricity",
    batterie: "Battery",
    eauxUsees: "Waste water",
    camping: "Camping",
    aireDeRepos: "Rest area",
    peage: "Toll",
    totalVoyage: "Total trip",
    enregistreFlash: "✓ Saved",
    departLabel: "Departure",
    arriveeLabel: "Arrival",
    catFinancement: "Financing",
    catAssurance: "Insurance",
    catControle: "MOT",
    catGarage: "Garage",
    catPeage: "Toll",
    catLavage: "Wash",
    catEau: "Water",
    catGaz: "Gas",
    catCamping: "Camping",
    catAire: "Rest area",
    catParking: "Parking",
    catHivernage: "Winter storage",
    catContravention: "Fine",

    // Rapport
    rapport_titre: "Report",
    mesStats: "My stats",
    passeportQR: "QR Passport",
    donneesPrivees: "Private data — not included in QR",
    kilometrage_label: "MILEAGE",
    kmAuCompteur: "km on odometer",
    kmParcourus: "km travelled",
    consommation: "AVERAGE CONSUMPTION",
    depensesTotales: "TOTAL EXPENSES",
    statsVoyage: "TRIP STATISTICS",
    aucunVoyage: "No trip recorded",
    telechargerPDF: "Download PDF",
    partagerPasseport: "📤 Share passport",
    idCertificat: "CERTIFICATE ID",
    statistiques: "STATISTICS",
    verificationsEffectuees: "Checks performed",
    interventionsEnregistrees: "Services recorded",
    derniereActivite: "Last activity",
    facturesGarage: "GARAGE INVOICES",
    van: "VAN",
    totalDepenses: "Total expenses",
    consommationLabel: "Consumption",
    partagerTitre: "Maintenance passport",
    partagerTexte: "Here is the maintenance passport of my campervan",
    // Secours
    resteCalme: "Stay calm, we're here. 🤜",
    enCasAccident: "In case of accident",
    procedureSecurite: "Procedure · Safety · Assistance",
    guideConstat: "European accident report guide",
    remplirConstat: "Fill it out correctly step by step",
    servicesProches: "Nearby services",
    garageStation: "Garage / Breakdown & Petrol station",
    appelRapide: "QUICK CALL",
    pompiers: "Fire brigade",
    police: "Police",
    europe: "Europe",
    suivezEtapes: "Follow these steps in order",
    securiserZone: "Secure the area",
    securiserZoneDesc: "Turn off the engine. Put on your hi-vis jacket BEFORE getting out. Place the triangle at least 30m away.",
    verifierBlesses: "Check for injuries",
    verifierBlessesDesc: "If seriously injured: call 15 (SAMU) or 18 (fire brigade). Do not move the injured.",
    appelerSecours: "Call emergency services",
    appelerSecoursDesc: "Police: 17 · SAMU: 15 · Fire brigade: 18 · European number: 112",
    contacterAssurance: "Contact your insurer",
    contacterAssuranceDesc: "Report the claim within 5 working days. Fill in the accident report.",
    huitEtapes: "8 steps to fill it out correctly",
    ouvreMaps: "Opens Google Maps near your location",
    garageDepannage: "Garage / Breakdown",
    mapsPres: "Google Maps opens near you",
    stationService: "Petrol station",
    retour: "← Back",
    constatStep1title: "Date, time and location",
    constatStep1desc: "Note the exact date, time and address of the accident.",
    constatStep2title: "Injuries?",
    constatStep2desc: "Indicate if there are any injuries. If so, call 15 immediately.",
    constatStep3title: "Material damage",
    constatStep3desc: "Describe the visible damage to each vehicle. Take photos.",
    constatStep4title: "Witnesses",
    constatStep4desc: "Take down the names and contact details of all witnesses.",
    constatStep5title: "Vehicle A & B",
    constatStep5desc: "Fill in the details of each vehicle: make, model, registration.",
    constatStep6title: "Insurance",
    constatStep6desc: "Note the policy numbers and insurer contact details of both parties.",
    constatStep7title: "Accident sketch",
    constatStep7desc: "Draw a clear diagram of the vehicle positions at the time of impact.",
    constatStep8title: "Mandatory signatures",
    constatStep8desc: "Both drivers MUST sign the report. Without signatures, it has no legal value.",
    constatStep9title: "Never admit fault",
    constatStep9desc: "Do not sign any document without your insurer's agreement.",
    // Dossiers
    garage: "Garage",
    factures: "Invoices",
    nouvelleFacture: "New invoice",
    prendrePhoto: "📷 Take a photo",
    photoChange: "✅ Photo taken — change",
    sauvegarde: "Saving…",
    chargement: "Loading…",
    aucuneFacture: "No invoice",
    expire: "Expired",
    aJour: "Up to date",
    aucuneDateRappel: "No date — reminder won't appear on Home",
    docExpire: "Document expired — renew as soon as possible",
    joursRestants: " day(s) remaining — reminder active on Home",
    prochaineRevisionA: "Next service at",
    nomAssurance: "INSURANCE NAME",
    adresse: "ADDRESS",
    numeroContrat: "POLICY NUMBER",
    numereTelephone: "PHONE NUMBER",
    exAssurance: "e.g. AXA, Allianz…",
    exAdresse: "e.g. 12 Peace Street, London",
    exContrat: "e.g. 12345678",
    exTel: "e.g. 0800 000 000",
    echeanceLabel: "EXPIRY DATE",
    nomGarage: "GARAGE NAME",
    exGarage: "e.g. Dupont Garage",
    exAdresseGarage: "e.g. 12 Marshal Avenue, Lyon",
    exTelGarage: "e.g. 04 00 00 00 00",
    exKmRevision: "e.g. 65,000",
    controleTechnique: "MOT",
    aucuneDate: "No date",
    // Checklist
    attentionBtn: "Warning!",
    problemeBtn: "❌ Issue",
    diagnosticOBD2: "OBD2 Diagnostic",
    bientotDispo: "🚧 COMING SOON",
    diagIA_titre: "AI Diagnostics",
    diagIA_sous_titre: "Identify your dashboard warning lights",
    diagIA_desc: "Take a photo of your dashboard warning lights. AI identifies each light, explains the likely cause and tells you what to do next.",
    diagIA_photo_label: "Photograph your warning lights",
    diagIA_photo_desc: "AI identifies each light and explains the likely cause and what to do next",
    diagIA_feat1: "Instant warning light identification",
    diagIA_feat2: "AI analysis of the likely cause",
    diagIA_feat3: "Emergency advice and next steps",
    diagIA_soon: "Available in CheckVan version 2",
    diagIA_btn: "Scan my warning lights — Coming soon",
    obd2Soon: "Feature under development",
    connecterOBD2: "Connect an OBD2 adapter",
    // Items Départ — Voyage
    dep_fenetre: "Windows closed", dep_fenetre_desc: "Locked and watertight",
    dep_store: "Awning retracted", dep_store_desc: "Folded in",
    dep_frigo: "Fridge on 12V", dep_frigo_desc: "Switch to battery",
    dep_antenne: "TV antenna", dep_antenne_desc: "Folded and secured",
    dep_robinets: "Taps closed", dep_robinets_desc: "Water circuit off",
    dep_gaz: "Gas off", dep_gaz_desc: "Main valve closed",
    dep_joints: "Window seals", dep_joints_desc: "No cracks or peeling",
    dep_toit: "Roof and skylights", dep_toit_desc: "Watertight, no cracks",
    dep_trappe: "Fresh water hatch", dep_trappe_desc: "No leaks around it",
    dep_marchepied: "Step retracted", dep_marchepied_desc: "Secured for the road",
    dep_cable220: "220V cable", dep_cable220_desc: "Disconnected and stored",
    dep_placards: "Cupboards closed", dep_placards_desc: "All locked",
    // Items Départ — Hivernal
    hiv_batterie: "Battery disconnected", hiv_batterie_desc: "Negative terminal removed",
    hiv_eau: "Water circuits drained", hiv_eau_desc: "Pump, water heater, hoses",
    hiv_antigel: "Antifreeze added", hiv_antigel_desc: "Traps and toilet",
    hiv_gaz: "Gas closed", hiv_gaz_desc: "Bottles disconnected",
    hiv_frigo: "Fridge open", hiv_frigo_desc: "Door propped open",
    hiv_ventilation: "Ventilation open", hiv_ventilation_desc: "Prevent condensation",
    hiv_pneus: "Tyre pressure", hiv_pneus_desc: "Inflate by +0.2 bar",
    hiv_bache: "Cover installed", hiv_bache_desc: "Protected from UV and moisture",
    // Items Départ — Sécurité
    sec_gilet: "Hi-vis jackets", sec_gilet_desc: "Accessible without opening the boot",
    sec_triangle: "Safety triangle", sec_triangle_desc: "Compliant and accessible",
    sec_extincteur: "Fire extinguisher", sec_extincteur_desc: "Charged and accessible",
    sec_trousse: "First aid kit", sec_trousse_desc: "Complete and up to date",
    sec_detecteur: "CO/Gas detector", sec_detecteur_desc: "Tested and working",
    sec_assurance: "Insurance up to date", sec_assurance_desc: "Green card in vehicle",
    sec_permis: "Licence & documents", sec_permis_desc: "Present in the vehicle",
    // Départ
    toutVerifie: "✓ All checked — Have a good trip!",
    ajouterBtn: "Add",
    nouvelElement: "New item to check…",
    ajoutezPropres: "Add your own items to check before departure",
    aNePasOublier: "DON'T FORGET",
    supprimer: "🗑️ Delete",
    stockagePlein: "⚠️ Storage almost full — delete some photos",
    confirmerSuppression: "Confirm?",
    viderCache: "Clear local cache",
    tabVoyage: "Trip",
    tabHivernal: "Winter",
    tabSecurite: "Safety",
    tabPerso: "Custom",
    // Autonomie
    jour: "day",
    surLabel: "of",
    capacitesVan: "VAN CAPACITIES",
    valider: "Confirm",
    capaciteEau: "Water capacity",
    capaciteGaz: "Gas capacity",
    capaciteEauxUsees: "Waste water capacity",
    renseignezCapacites: "Enter your van's capacities to get started",
    autonomieSuffisante: "✓ Sufficient autonomy",
    autonomieLimitee: "⚠ Limited autonomy",
    ressourcesCritiques: "⛽ Critical resources",
    avantVidange: "before emptying",
    conditionsVoyage: "TRIP CONDITIONS",
    personnesABord: "People on board",
    reservoirCritique: "Critical tank — find a water point",
    bouteilleVide: "Bottle almost empty — refill soon",
    tankCharge: "Tank full — plan a drain",
    batterieFaible: "Low battery — plug in or expose solar panels",
    predictionsAvantDepart: "Pre-departure predictions",
    // Onboarding
    configurezVotreVan: "Set up your van",
    aFaireUneFois: "Done only once",
    exNomVan: "e.g. Vagabond, My Hymer…",
    nomRequis: "Van name is required.",
    enregistrementEnCours: "Saving…",
    // Premium
    plansCheckVan: "✨ CheckVan Plans",
    choisissezFormule: "Choose your plan",
    mensuel: "Monthly",
    annuel: "Annual −30%",
    gratuit: "Free",
    premium: "Premium",
    ultra: "Ultra",
    recommande: "★ RECOMMENDED",
    parMois: "/mo",
    parAn: "/yr",
    ou: "or",
    planActuel: "Current plan",
    choisirPremium: "Choose Premium",
    choisirUltra: "Choose Ultra",
    fermer: "Close",
    // Premium features
    feat_1Vehicule: "1 vehicle",
    feat_checklistEntretien: "Maintenance checklist",
    feat_documents: "Documents",
    feat_rappels: "Reminders",
    feat_boutonSecours: "Emergency button",
    feat_certificatQR: "QR certificate",
    feat_meteoJour: "Today's weather",
    feat_toutGratuit: "Everything in Free +",
    feat_multilingue: "Multilingual FR/EN (auto)",
    feat_diagnosticIA: "AI warning light diagnosis",
    feat_exportPDF: "Advanced PDF export",
    feat_depenses3mois: "Expenses & Mileage 3 months",
    feat_stats3mois: "Statistics 3 months",
    feat_historique3mois: "History 3 months",
    feat_meteo3jours: "3-day weather forecast",
    feat_toutPremium: "Everything in Premium +",
    feat_pdfOCR: "Advanced PDF + OCR Scanner",
    feat_notifications: "Push notifications",
    feat_pwa: "Installable PWA",
    feat_depensesIllimite: "Unlimited expenses & mileage",
    feat_stats12mois: "12-month statistics",
    feat_historiqueIllimite: "Unlimited history",
    feat_obd2: "OBD2 diagnostic 🔌",
    feat_diagIA: "AI warning light diagnosis 🔍",
    feat_meteo7jours: "7-day weather forecast",
    // Menu
    monVan: "My Van",
    compte: "ACCOUNT",
    reconfigurerVan: "🔄 Reconfigure van",
    seDeconnecter: "⏏ Sign out",
    // Accueil — modals
    conseilsVoyage: "💡 Travel tips",
    carnetBord: "Digital logbook",
    langue: "LANGUAGE",
    compteConnecte: "CONNECTED ACCOUNT",
    voirPlans: "View Premium plans",
    installerApp: "Install app on phone",
    activerNotifs: "Enable notifications",
    partagerApp: "Share the app",
    supprimerCompte: "Delete my account",
    confirmerSuppressionCompte: "Confirm deletion?",
    suppressionEnCours: "Deleting...",
    erreurReconnexion: "Please sign out and sign back in before deleting your account.",
    erreurSuppression: "Error: ",
    cguConfidentialite: "Terms & Privacy policy",
    conseilEauxUsees: "Waste water almost full — empty it as a priority.",
    conseilEauBasse: "Critical water level — find a water point.",
    conseilGazBas: "Gas bottle almost empty — refill soon.",
    conseilBatterieBasse: "Low battery — plug in or expose the solar panels.",
    conseilSurveiller: "Some resources to monitor before departure.",
    conseilOk: "Good autonomy — set off with peace of mind.",
    conseilTitre1: "Weight — GVWR",
    conseilTexte1: "Most motorhomes are driven with a standard licence and limited to 3.5 tonnes. The payload is the difference between the kerb weight and the GVWR (usually 400 to 600 kg). Calculate: Passengers + full water tank (100L = 100kg) + gas + personal effects + bikes.\n\n💬 Tip: Never leave with a full water tank if you have a long drive ahead.",
    conseilTitre2: "Autonomy and Resources",
    conseilTexte2: "• Water: ~20 litres/day/person. With 100L, you'll last 2 to 3 days for two.\n• Energy: Don't let the battery drop below 12.2V (50% charge) to avoid damage.\n• Gas: A 13kg bottle lasts several weeks in summer, but only 3 to 4 days in winter with heavy heating.",
    conseilTitre3: "Dimensions and Navigation",
    conseilTexte3: "• Height: Between 2.80m and 3.10m. Note it on a post-it on your dashboard.\n• Overhang: On tight corners, the rear swings out. Always keep a safety margin.",
    conseilTitre4: "Digital Organisation",
    conseilTexte4: "• Parking apps to find service areas or authorised spots.\n• Departure checklists: close gas bottles, retract the step, lock cupboards, close skylights.",
    conseilTitre5: "The Peace of Mind Extra",
    conseilTexte5: "Bring a small toolkit (fuses, bulbs, cable ties). Motorhomes vibrate a lot — it's not unusual to need to tighten a screw or replace a water pump fuse on the road.",
    conseilTitre6: "Pets",
    conseilTexte6: "Before leaving\n• Admin: Pet identified (chip/tattoo), vaccinations up to date (rabies required abroad) and European passport if crossing borders.\n• Health: Bring a first aid kit (tick remover, antiseptic) and plan for travel sickness.\n\nOn the road — Safety\n• Restraint required: Safety harness or fixed transport crate (never a free-roaming animal while driving).\n• Breaks: Stop every two hours for water, toilet and a stretch.",
    // Checklist véhicule — catégories
    catMoteur: "Engine & Fluids",
    catPneus: "Tyres",
    catEclairage: "Lighting",
    catCellule: "Living area",
    // Checklist véhicule — items
    ent_huile: "Engine oil level", ent_huile_desc: "Gauge between min and max",
    ent_refroid: "Coolant", ent_refroid_desc: "Level at cold mark",
    ent_frein: "Brake fluid", ent_frein_desc: "Above minimum",
    ent_laveglace: "Windscreen washer", ent_laveglace_desc: "Reservoir full",
    ent_filtre_air: "Air filter", ent_filtre_air_desc: "Condition and cleanliness",
    ent_pression: "Tyre pressure (front & rear)", ent_pression_desc: "As per manufacturer",
    ent_usure_av: "Front tyre wear", ent_usure_av_desc: "Tread depth > 1.6 mm",
    ent_usure_ar: "Rear tyre wear", ent_usure_ar_desc: "Tread depth > 1.6 mm",
    ent_secours: "Spare wheel", ent_secours_desc: "Inflated and accessible",
    ent_phares: "Headlights and front lights", ent_phares_desc: "Working",
    ent_stop: "Brake lights", ent_stop_desc: "Working",
    ent_cligno: "Indicators", ent_cligno_desc: "Front and rear",
    ent_recul: "Reversing lights + plate", ent_recul_desc: "Working",
    ent_ce_freins: "Brakes", ent_ce_freins_desc: "Wear and efficiency",
    ent_ce_batt: "Battery", ent_ce_batt_desc: "Charge and general condition",
    ent_ce_essuie: "Wipers", ent_ce_essuie_desc: "Blade condition",
    ent_ce_clim: "Air conditioning", ent_ce_clim_desc: "Working and clean filter",
    obd2Desc: "Connect a Bluetooth OBD2 adapter to read your campervan's error codes and get an AI analysis.",
    // Outils
    outils: "Tools",
    outils_titre: "Field tools",
    outils_sous_titre: "Your smartphone's sensors",
    outil_niveau: "Spirit level",
    outil_niveau_btn: "Enable level",
    outil_inclinometre: "Safety inclinometer",
    outil_incl_btn: "Enable inclinometer",
    outil_boussole: "Solar compass",
    outil_boussole_btn: "Enable compass",
    outil_conseil_solaire: "Park facing SOUTH for optimal solar panel output",
    inactif: "Inactive",
    autoriser_capteur: "Allow sensor access (iOS)",
    desactiver: "Disable",
    cale_gauche: "Chock LEFT wheel",
    cale_droite: "Chock RIGHT wheel",
    cale_avant: "Chock FRONT wheels",
    cale_arriere: "Chock REAR wheels",
    incl_ok: "✅ Normal tilt",
    incl_warn: "⚠️ Caution — significant tilt",
    incl_danger: "🚨 DANGER — risk of tipping",
    activer_gps: "Enable GPS",
    lever: "Sunrise",
    coucher: "Sunset",
    niveau_titre: "Spirit level",
    niveau_ok: "✅ Vehicle is level",
    niveau_cale_gauche: "Chock the LEFT wheel",
    niveau_cale_droite: "Chock the RIGHT wheel",
    niveau_cale_avant: "Chock the FRONT wheels",
    niveau_cale_arriere: "Chock the REAR wheels",
    niveau_activer: "Enable level",
    niveau_permission: "Allow sensor access",
    inclinometre_titre: "Safety inclinometer",
    inclinometre_ok: "✅ Normal tilt",
    inclinometre_attention: "⚠️ Caution — significant tilt",
    inclinometre_danger: "🚨 DANGER — risk of tipping",
    boussole_titre: "Solar compass",
    boussole_lever: "Sunrise",
    boussole_coucher: "Sunset",
    boussole_activer_gps: "Enable GPS",
  },
};
